import Vue from 'vue'

import { createResource } from './resource'
import { merge } from 'lodash'

import { createClient } from './client'
import { createAuth } from './auth'


import { createModel } from './model'
import { createSearch } from './search'
import { createList } from './list'


class Api {

  constructor({
    baseURL = null,
    resources = {},
  } = {}) {

    const auth = createAuth(createClient({ baseURL }))
    const client = createClient({ baseURL })

    client.interceptors.request.use(function(config) {
      config.headers['Authorization'] = `Bearer ${auth.accessToken.value}`
      return config
    }, function(error) {
      return Promise.reject(error)
    })
    
    client.interceptors.response.use(function(response) {
      return response
    }, function(error) {
      // logout when authentication fails.
      if (error && error.response && error.response.status === 401) {
        auth.logout()
      }
    
      return Promise.reject(error)
    })

    this.auth = auth
    this.client = client
    this.resources = resources
  }

  resource(name, options = {}) {
    return createResource(this.client, name, merge({}, this.resources[name] || {}, options))
  }

  // legacy
  createModel(resource, options) {
    return createModel(this.client, resource, options)
  }

  createSearch(resource, options) {
    return createSearch(this.client, resource, options)
  }

  createList(resource, options) {
    return createList(this.client, resource, options)
  }


}

Api.install = function(Vue, options = {}) {

  Vue.prototype.$api = new Api(options)

}

export default Api

